<template>
    <main class="flex-1 relative overflow-y-auto py-6 focus:outline-none" tabindex="0">
        <form @submit.prevent="saveCenter">
            <div class="max-w-7xl mx-auto sm:px-6 lg:px-8 px-5">
                <div class="md:flex md:items-center md:justify-between">
                    <div class="flex-1 min-w-0">
                        <h1 class="py-0.5 text-2xl font-semibold text-gray-900">{{ $t('Edit center') }}</h1>
                    </div>
                    <div class="mt-4 flex md:mt-0 md:ml-4">
                        <button
                            class="btn btn-red shadow-sm rounded-md"
                            type="button"
                            @click="deleteCenterModal = true"
                        >
                            {{ $t('Delete center') }}
                        </button>
                    </div>
                </div>
            </div>
            <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
                <div v-show="synced" class="mt-6 p-4 bg-gray-600 shadow">
                    <p class="text-white font-medium">
                        <span class="text-orange-400">{{ $t("WARNING") }}</span>
                        {{ $t("All GdR Centers must be operated by 'SixDesk SAT:GDR', some main input fields are disabled") }}.
                    </p>
                </div>
                <div class="mt-6 shadow sm:rounded-lg">
                    <loading :status="loading"/>
                    <div class="bg-white md:grid md:grid-cols-3 md:gap-6 px-4 py-5 sm:p-6">
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Center details') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('This information will be displayed publicly') }}.
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="name">{{ $t('Name') }}<strong class="text-red-600"> *</strong></label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <input
                                            id="name"
                                            v-model="center.name"
                                            :placeholder="$t('Name')"
                                            :class="{ 'text-gray-500 border-gray-300' : synced }"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            required
                                            :disabled="synced"
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="email">{{ $t('Emails') }}</label>
                                    <input-email
                                        id="emails"
                                        ref="emails"
                                        :emailList="center.emails"
                                    ></input-email>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="phone">{{ $t('Phone') }}</label>
                                    <input-phone
                                        id="phones"
                                        ref="phones"
                                        :phoneList="center.phones"
                                    ></input-phone>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="observations">{{ $t('Observations') }}</label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <textarea-autosize
                                            v-model="center.observations"
                                            :placeholder="$t('Observations')"
                                            class="form-textarea block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        />
                                    </div>
                                </div>
                                <div v-if="synced" class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="status_gdr">{{ $t('Status') }}</label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <select
                                            id="status_gdr"
                                            v-model="center.status_gdr"
                                            class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                        >
                                            <option :value="null" disabled>{{ $t('Select an option') }}</option>
                                            <option v-for="state in states" :value="state">{{ $t(state) }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div v-if="synced" class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="formations">{{ $t('Formations') }}</label>
                                    <template v-for="(formation, index) in formations">
                                        <div class="mt-1 flex rounded-md">
                                            <input-switch
                                                :id="'formation_' + index"
                                                v-model="realizedFormations[index]"
                                                :disabled-label="formation.name"
                                                :enabled-label="formation.name"
                                            ></input-switch>
                                        </div>
                                    </template>
                                </div>
                            </div>
                            <!--<div class="mt-6">
                                <label class="block text-sm leading-5 font-medium text-gray-700">{{ $t('Avatar') }}</label>
                                <div class="mt-2 flex items-center select-none">
                                    <div class="avatar-editor relative inline-block h-12 w-12 overflow-hidden bg-gray-100">
                                        <button
                                            v-show="center.avatar != null || center.avatar != ''"
                                            class="avatar-editor-remove absolute top-0 right-0 items-center p-0.5 rounded-full leading-4 bg-red-600 text-white cursor-pointer"
                                            type="button"
                                            @click="removeAvatar"
                                            disabled
                                        >
                                            <svg-vue class="h-4 w-4 p-px" icon="font-awesome.times-light"></svg-vue>
                                        </button>
                                        <img
                                            :src="center.avatar64 ? `data:image/png;base64,${center.avatar_preview}` : center.avatar_preview"
                                            alt="Center avatar"
                                            class="h-full w-full text-gray-300 rounded-full object-scale-down"
                                        />
                                    </div>
                                    <span class="ml-5 rounded-md shadow-sm">
                                        <input ref="changeAvatar" accept=".png,.jpg,.jpeg" hidden type="file" @change="changeAvatar($event)">
                                        <button
                                            class="py-2 px-3 border border-gray-300 rounded-md text-sm leading-4 font-medium text-gray-700 hover:text-gray-500 focus:outline-none focus:border-blue-300 focus:shadow-outline-blue active:bg-gray-50 active:text-gray-800 transition duration-150 ease-in-out"
                                            type="button"
                                            @click="selectAvatar"
                                            disabled
                                        >
                                            {{ $t('Change') }}
                                        </button>
                                    </span>
                                </div>
                            </div>-->
                        </div>
                        <div class="md:col-span-3">
                            <div class="py-3">
                                <div class="border-t border-gray-200"></div>
                            </div>
                        </div>
                        <div class="md:col-span-1">
                            <h3 class="text-lg font-medium leading-6 text-gray-900">{{ $t('Center settings') }}</h3>
                            <p class="mt-1 text-sm leading-5 text-gray-500">
                                {{ $t('Center settings') }}.
                            </p>
                        </div>
                        <div class="mt-5 md:mt-0 md:col-span-2">
                            <div class="grid grid-cols-3 gap-6">
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="id_ext">{{ $t('External ID') }}</label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <input
                                            id="id_ext"
                                            v-model="center.id_ext"
                                            :placeholder="$t('External ID')"
                                            class="form-input block w-full transition duration-150 ease-in-out sm:text-sm sm:leading-5 text-gray-500 border-gray-300"
                                            type="text"
                                            disabled
                                        >
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="support_code">{{ $t('Support code') }}</label>
                                    <support-code
                                        :orgCode="center.organization?.support_code"
                                        :isLocal="center.organization?.id_ext == null"
                                        onlyOrg
                                        wrapper="w-28 mt-1.5"
                                    >
                                    </support-code>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="lang_id">{{ $t('Languages') }}<strong class="text-red-600"> *</strong></label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <select
                                            id="lang_id"
                                            v-model="center.lang_id"
                                            :class="{ 'text-gray-500 border-gray-300' : synced }"
                                            class="mt-1 block form-select w-full py-2 px-3 border border-gray-300 bg-white rounded-md shadow-sm focus:outline-none focus:shadow-outline-blue focus:border-blue-300 transition duration-150 ease-in-out sm:text-sm sm:leading-5"
                                            required
                                            :disabled="synced"
                                        >
                                            <option :value="null" disabled>{{ $t('Select an option') }}</option>
                                            <option v-for="language in languages" :value="language.id">{{ language.name }}</option>
                                        </select>
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="org">{{ $t('Organization') }}<strong class="text-red-600"> *</strong></label>
                                    <div class="mt-1 relative rounded-md shadow-sm">
                                        <input-select
                                            id="org"
                                            v-model.lazy="center.org_id"
                                            :options="orgs"
                                            option-label="name"
                                            required
                                            searchable
                                            :disabled="synced"
                                        >
                                            <template v-slot:selectedOption="props">
                                                <template v-if="props && !props.anySelected">
                                                    <span class="block truncate">{{ $t('Select an option') }}</span>
                                                </template>
                                                <template v-else>
                                                    <div class="flex-shrink-0 inline-block">
                                                        <img :src="props.option.avatar" alt="Icon" class="w-5 h-auto rounded-full object-scale-down">
                                                    </div>
                                                    <span class="block truncate">{{ props.option.name }}</span>
                                                    <div v-if="props.option.phones.length > 0" class="hidden xl:flex xl:items-center xl:gap-2 truncate font-normal text-gray-500">
                                                        <svg-vue class="h-3 w-3 text-gray-500" icon="font-awesome.phone-solid"></svg-vue>
                                                        <span v-for="(phone, index) in props.option.phones">{{ phone.country_code == '34' ? phone.number : "+" + phone.country_code + phone.number }}</span>
                                                    </div>
                                                </template>
                                            </template>
                                            <template v-slot:selectOption="props">
                                                <div class="flex items-center space-x-3">
                                                    <div class="flex-shrink-0 inline-block">
                                                        <img :src="props.option.avatar" alt="Icon" class="w-5 h-auto rounded-full object-scale-down">
                                                    </div>
                                                    <div class="font-normal block truncate">
                                                        {{ props.option.name }}
                                                    </div>
                                                    <div v-if="props.option.phones.length > 0" class="hidden xl:flex xl:items-center xl:gap-2 truncate font-normal text-gray-500">
                                                        <svg-vue class="h-3 w-3 text-gray-500" icon="font-awesome.phone-solid"></svg-vue>
                                                        <span v-for="(phone, index) in props.option.phones">{{ phone.country_code == '34' ? phone.number : "+" + phone.country_code + phone.number }}</span>
                                                    </div>
                                                </div>
                                            </template>
                                        </input-select>
                                    </div>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="status">{{ $t('Users') }}</label>
                                    <list-view
                                        id="users"
                                        type="users"
                                        :list="center.users"
                                        wrapper="mt-1"
                                        searchable
                                        router
                                    ></list-view>
                                </div>
                                <div class="col-span-3">
                                    <label class="block text-sm font-medium leading-5 text-gray-700" for="status">{{ $t('Status') }}</label>
                                    <div class="mt-1 flex rounded-md">
                                        <input-switch
                                            id="status"
                                            v-model="center.status"
                                            :disabled-label="$t('The center is disabled')"
                                            :enabled-label="$t('The center is activated')"
                                            :readonly="synced"
                                        ></input-switch>
                                    </div>
                                    <div class="mt-2 relative text-xs text-gray-500">
                                        {{ $t('When the center is deactivated, the users in this center will not be able to create tickets') }}.
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="bg-gray-100 text-right px-4 py-3 sm:px-6">
                        <span class="inline-flex">
                            <router-link
                                class="btn btn-secondary shadow-sm rounded-md mr-4"
                                to="/dashboard/admin/centers"
                            >
                                {{ $t('Close') }}
                            </router-link>
                            <button
                                class="btn btn-green shadow-sm rounded-md"
                                type="submit"
                            >
                                {{ $t('Edit center') }}
                            </button>
                        </span>
                    </div>
                </div>
            </div>
        </form>
        <div v-show="deleteCenterModal" class="fixed z-20 inset-0 overflow-y-auto">
            <div class="flex items-end justify-center min-h-screen pt-4 px-4 pb-20 text-center sm:block sm:p-0">
                <transition
                    duration="300"
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0"
                    enter-to-class="opacity-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100"
                    leave-to-class="opacity-0"
                >
                    <div v-show="deleteCenterModal" class="fixed inset-0 transition-opacity">
                        <div class="absolute inset-0 bg-gray-500 opacity-75"></div>
                    </div>
                </transition>
                <span class="hidden sm:inline-block sm:align-middle sm:h-screen"></span>&#8203;
                <transition
                    enter-active-class="ease-out duration-300"
                    enter-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                    enter-to-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-active-class="ease-in duration-200"
                    leave-class="opacity-100 translate-y-0 sm:scale-100"
                    leave-to-class="opacity-0 translate-y-4 sm:translate-y-0 sm:scale-95"
                >
                    <div
                        v-show="deleteCenterModal"
                        aria-labelledby="modal-headline"
                        aria-modal="true"
                        class="inline-block align-bottom bg-white rounded-lg text-left overflow-hidden shadow-xl transform transition-all sm:my-8 sm:align-middle sm:max-w-lg sm:w-full"
                        role="dialog"
                    >
                        <div class="bg-white px-4 pt-5 pb-4 sm:p-6 sm:pb-4">
                            <div class="sm:flex sm:items-start">
                                <div class="mx-auto flex-shrink-0 flex items-center justify-center h-12 w-12 rounded-full bg-red-100 sm:mx-0 sm:h-10 sm:w-10">
                                    <svg-vue class="h-6 w-6 pb-1 text-red-600" icon="font-awesome.exclamation-triangle-light"></svg-vue>
                                </div>
                                <div class="mt-3 text-center sm:mt-0 sm:ml-4 sm:text-left">
                                    <h3 id="modal-headline" class="text-lg leading-6 font-medium text-gray-900">
                                        {{ $t('Delete center') }}
                                    </h3>
                                    <div class="mt-2">
                                        <p class="text-sm leading-5 text-gray-500">
                                            {{ $t('Are you sure you want to delete the center?') }}
                                            {{ $t('All data will be permanently removed') }}.
                                            {{ $t('This action cannot be undone') }}.
                                        </p>
                                    </div>
                                    <div v-show="!canDelete" class="mt-2">
                                        <p class="text-sm leading-5 text-red-500">
                                            {{ $t('This center has users assigned, delete the users before deleting the center') }}
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="bg-gray-100 px-4 py-3 sm:px-6 sm:flex sm:flex-row-reverse">
                            <button
                                class="btn btn-red mr-2 sm:mr-0"
                                type="button"
                                @click="deleteCenter"
                                :disabled="!canDelete"
                            >
                                {{ $t('Delete center') }}
                            </button>
                            <button
                                class="btn btn-white mr-0 sm:mr-2"
                                type="button"
                                @click="deleteCenterModal = false"
                            >
                                {{ $t('Cancel') }}
                            </button>
                        </div>
                    </div>
                </transition>
            </div>
        </div>
    </main>
</template>

<script>
export default {
    name: "edit-center",
    metaInfo() {
        return {
            title: this.$i18n.t('Edit center')
        }
    },
    data() {
        return {
            deleteCenterModal: false,
            formations: [],
            realizedFormations: [],
            languages: [],
            states: [],
            orgs: [],
            center: {
                id: null,
                id_ext: null,
                name: null,
                avatar: null,
                //avatar_preview: null,
                observations: null,
                emails: [],
                phones: [],
                formations: [],
                formation_ids: [],
                user_ids: null,
                lang_id: null,
                org_id: null,
                users: [],
                user_ids: [],
                status: true,
                status_gdr: null
            },
            canDelete: true,
        }
    },
    computed: {
        loading() {
            return this.$store.state.loading.states.main;
        },
        synced() {
            return this.center.id_ext != null
                && this.center.id_ext != '';
        },
    },
    watch: {
        realizedFormations(newFormations, oldFormations) {
            this.center.formation_ids = [];
            for (let i = 0; i < this.formations.length; i++) {
                if (this.realizedFormations[i]) this.center.formation_ids.push(this.formations[i].id);
            }
        }
    },
    beforeMount() {
        this.$store.commit('resetLoading');
    },
    mounted() {
        this.getStates();
        this.getLanguages();
        this.getOrgs();
        this.getCenter();
    },
    methods: {
        async saveCenter() {
            const self = this;
            self.$store.commit('loadSections');
            self.center.phones = [...await self.$refs.phones.savePhones()];
            self.center.emails = [...await self.$refs.emails.saveEmails()];
            //self.center.formation_ids = self.formations.filter(formation => formation.realized).map(formation => formation.id);
            axios.put('api/dashboard/admin/centers/' + self.$route.params.id, self.center).then(function (response) {
                self.$store.commit('unloadSections');
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data updated correctly').toString(),
                    type: 'success'
                });
            }).catch(function () {
                self.$store.commit('unloadSections');
            });
        },
        getCenter() {
            const self = this;
            self.$store.commit('loadSections');
            axios.get('api/dashboard/admin/centers/' + self.$route.params.id).then(function (response) {
                self.center = response.data;
                self.center.avatar_preview = response.data.avatar;
                self.canDelete = !response.data.users.length > 0;
                self.getFormations();
                self.$store.commit('unloadSections');
            }).catch(function () {
                self.$store.commit('unloadSections');
            });
        },
        getFormations() {
            const self = this;
            self.$store.commit('loadSections');
            axios.get('api/dashboard/admin/formations').then(function (response) {
                self.formations = response.data;
                for (let i = 0; i < self.formations.length; i++) {
                    self.realizedFormations.push(self.center.formation_ids.includes(self.formations[i].id));
                }
                self.$store.commit('unloadSections');
            }).catch(function () {
                self.$store.commit('unloadSections');
            });
        },
        getLanguages() {
            const self = this;
            self.$store.commit('loadSections');
            axios.get('api/dashboard/admin/languages').then(function (response) {
                self.languages = response.data;
                self.$store.commit('unloadSections');
            }).catch(function () {
                self.$store.commit('unloadSections');
            });
        },
        getStates() {
            const self = this;
            self.$store.commit('loadSections');
            axios.get('api/dashboard/admin/centers/states').then((response) => {
                self.states = response.data.states;
                self.$store.commit('unloadSections');
            }).catch(function () {
                self.$store.commit('unloadSections');
            });
        },
        getOrgs() {
            const self = this;
            self.$store.commit('loadSections');
            axios.get('api/dashboard/admin/orgs/list', {
                params: {
                    include: ["server", "phones"]
                }
            }).then(function (response) {
                self.orgs = response.data.orgs;
                self.$store.commit('unloadSections');
            }).catch(function () {
                self.$store.commit('unloadSections');
            });
        },
        selectAvatar() {
            this.$refs.changeAvatar.click();
        },
        removeAvatar() {
            this.center.avatar = null;
            this.center.avatar_preview = null;
            this.$refs.changeAvatar.value = '';
        },
        changeAvatar(event) {
            const self = this;
            if (event.target.files.length) {
                if (['image/png', 'mage/x-citrix-png', 'image/x-png', 'image/jpeg', 'image/x-citrix-jpeg'].includes(event.target.files[0].type)) {
                    self.center.avatar = event.target.files[0];
                    self.center.avatar_preview = URL.createObjectURL(event.target.files[0]);
                } else {
                    self.$notify({
                        title: self.$i18n.t('Unsupported file type').toString(),
                        text: self.$i18n.t('Only image type files are accepted').toString(),
                        type: 'error'
                    })
                }
            }
        },
        deleteCenter() {
            const self = this;
            axios.delete('api/dashboard/admin/centers/' + self.$route.params.id).then(function () {
                self.$notify({
                    title: self.$i18n.t('Success').toString(),
                    text: self.$i18n.t('Data deleted successfully').toString(),
                    type: 'success'
                });
                self.$router.push('/dashboard/admin/centers');
            }).catch(function () {
                self.deleteCenterModal = false;
            });
        }
    }
}
</script>
